<template>
  <v-dialog
		v-model="dialog"
		persistent
		width="1300"
	>
		<v-card>
			<!-- Cabecera del formulario -->
			<v-card-title class="headline">
				<v-flex xs9>
					<v-icon>picture_as_pdf</v-icon> REPORTE
				</v-flex>
				<v-spacer></v-spacer>
        <v-btn
          flat
          icon
          title="Ver en otra ventana"
          @click="openNewWindow()"
        >
          <v-icon>fullscreen</v-icon>
        </v-btn>
				<v-btn icon @click.native="close()">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex>
              <embed :src="obtenerUrl()" type="application/pdf" width="100%" height="700px">
		 
			 </v-flex>
        </v-layout>
      </v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>

export default {
	// Variables iniciales
	data () {
		return {
		     form:{},
			dialog: false,
			loading: false,
			url:'',
			api_backend: ''
		}
	},
		mounted () {
		this.$bus.$on('openDialogVerReporte', item => {
			//this.tipo_documento = this.obtenerTipo(item)
            this.form=item
			this.url = this.obtenerUrl()
			this.api_backend = process.env.API_URL.split('api/')
			this.dialog = true
		})
	},
	methods: {
		obtenerUrl(){
            try {
                let url
              
                  if(this.form.jefe == 0){  //  no es jefe  
                    url=`http://192.168.72.253:8080/jasperserver/flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=/reports/reports/RRHH_DESARROLLO/permisos&reportUnit=/reports/RRHH_DESARROLLO/permisos/rpt_asistencia_manual&standAlone=true&output=pdf&j_username=jasperadmin&j_password=jasperadmin&p_id_permiso=${parseInt(this.form.id)}`
                }
                    if(this.form.jefe == 1){      //es jefe 
                    url=`=${parseInt(this.form.id)}`
                }
                 
                return url
              
            } catch (error) {
                console.log(error)
            }
        },
		close () {
			this.loading = false
			this.dialog = false
		},
    openNewWindow () {
      window.open(this.api_backend[0]+this.documento)
    },
	} 

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/admin/registro_manual_asistencia/dialogs/VerReporte.vue